import { render, staticRenderFns } from "./studentEmploymentStatistics.vue?vue&type=template&id=38e68740&scoped=true&"
import script from "./studentEmploymentStatistics.vue?vue&type=script&lang=js&"
export * from "./studentEmploymentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./studentEmploymentStatistics.vue?vue&type=style&index=0&id=38e68740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e68740",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e68740')) {
      api.createRecord('38e68740', component.options)
    } else {
      api.reload('38e68740', component.options)
    }
    module.hot.accept("./studentEmploymentStatistics.vue?vue&type=template&id=38e68740&scoped=true&", function () {
      api.rerender('38e68740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/count/studentEmploymentStatistics.vue"
export default component.exports